module.exports = __webpack_public_path__ + "assets/img/Beyond-the-nets.af15ba5b.jpg";